export * from './dashboard.component';
export * from './upload-picture-dialog/upload-picture-dialog';
export * from './edit-screen-name/edit-screen-name';
export * from './followers-of-user/followers-of-user.component';
export * from './following-of-users/following-of-users.component';
export * from './user-activity/user-activity.component';
export * from './tab-routes';



// WEBPACK FOOTER //
// ./src/app/dashboard/index.ts